var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hr',{class:{
		[_vm.$style['hr']]: true,
		[_vm.$style['hr--with-margin']]: _vm.withMargin,
		[_vm.$style['hr--expanded']]: _vm.expanded
	}})
}
var staticRenderFns = []

export { render, staticRenderFns }